'use strict';

var _ = require('underscore');
var sw = require('js/lib/sw');
var ShapewaysModel = require('js/lib/models/ShapewaysModel');
var swRedux = require('js/lib/sw-redux');
// Uncomment for debug
// var loggerMiddlewear = require('js/lib/sw-redux/middlewear/logger');
var thunkMiddlewear = require('js/lib/sw-redux/middlewear/thunk');
var customMakerReducer = require('js/lib/components/CustomMaker/action-reducers');
var actionCreators = require('js/lib/components/CustomMaker/actionCreators');
var STATICS = require('js/lib/components/CustomMaker/statics');
var actions = require('js/lib/actions');
var storeDataUtils = require('js/lib/components/CustomMaker/storeDataUtils');
var bindStoreDataUtils = require('js/lib/actions/utils/bindStoreDataUtils');
var notifications = require('js/lib/notifications/sw-notifications');

/**
 * Takes a message string and returns an error object
 *
 * @param message
 * @return {{message: *}}
 */
function makeValidationError(message) {
  if (!_.isString(message)) {
    throw new Error('No Error Message Set');
  }
  return {
    message: message
  };
}

// Single source of truth
var CustomMakerModel = ShapewaysModel.extend({

  idAttribute: 'id',

  pluralName: 'customMakerModels',

  STORE_CHANGE_EVENT: 'swStoreChangeEvent',

  defaults: STATICS.INIT_DATA,

  actions: {
    'allActionsHandler': actions.ALL.type
  },

  initialize: function initialize() {
    var model = this;
    var middlewear = [thunkMiddlewear];

    // Uncomment for debug
    // middlewear.push(loggerMiddlewear);

    var createStoreWithMiddlewear = swRedux.applyMiddleware(middlewear)(swRedux.createStore);
    this.store = createStoreWithMiddlewear(customMakerReducer, this.attributes);
    this.store.subscribe(function swModelReduxTrigger() {
      model.updateAttrsFromState();
      model.trigger(model.STORE_CHANGE_EVENT, model.getState());
    });
    this.storeDataUtils = bindStoreDataUtils(storeDataUtils, this.getState.bind(this));

    sw.dispatch(actionCreators.setFromBackbone(this.attributes));
  },

  allActionsHandler: function allActionsHandler(currentAttributes, action) {
    if (this.store) {
      this.store.dispatch(action);
    }

    return {};
  },

  set: function set(key, val, options) {

    // Handle both `"key", value` and `{key: value}` -style arguments.
    var attrs;

    if (_.isObject(key)) {
      attrs = key;
      options = val;
    } else {
      (attrs = {})[key] = val;
    }

    var noDispatch = options && options.noDispatch;

    if (!noDispatch && this.store) {
      this.store.dispatch(actionCreators.setFromBackbone(attrs));
    } else {
      ShapewaysModel.prototype.set.apply(this, arguments);
    }

    return this;
  },

  updateAttrsFromState: function updateAttrsFromState() {
    var changedAttrs = this.changedAttributes(this.store.getState());
    if (changedAttrs) {
      this.set(changedAttrs, {noDispatch: true});
    }
  },

  getState: function getState() {
    return this.store.getState();
  },

  getLastState: function getLastState() {
    return this.store.getLastState();
  },

  /**
   * Checks to see if custom maker values are valid.
   *
   * returns empty array if valid.
   *
   * @return [{
	 * 	message: string
	 * }]
   */
  validate: function validate() {
    var errors = [];

    var hotspots = this.storeDataUtils.getHotspots(STATICS.TEXT);
    _.reduce(hotspots, function (errors, hotspot) {
      if (hotspot.type === STATICS.TEXT) {
        if (!_.isUndefined(hotspot.font_size) && _.isUndefined(hotspot.line_height)) {
          errors.push(makeValidationError('CustomMaker text box requires line height to be set if font size is set.'));
        }

        if (!_.isUndefined(hotspot.line_height) && _.isUndefined(hotspot.font_size)) {
          errors.push(makeValidationError('CustomMaker text box requires font size to be set if line height is set.'));
        }
      }
      return errors;
    }, errors);

    return errors;
  },

  /**
   * Check validation and pop noty's if there are errors
   * @return {boolean}
   */
  validateAndNotify: function validateAndNotify() {
    var errors = this.validate();

    if (!errors.length) {
      return true;
    }

    _.forEach(errors, function (error) {
      notifications.error(error.message);
    });
    return false;
  }
});

module.exports = CustomMakerModel;


